import axios from "../modules/axios";

export default {
	namespaced: true,
	state: {
		open: false,
		data: window.shop.cart,
		timeout: ""
	},
	mutations: {
		data: function(state, data) {
			state.data = data;
		},
		open: function(state, open) {
			state.open = open;
		},
		timeout: function(state, timeout) {
			state.timeout = timeout;
		}
	},
	actions: {
		async getData({ commit }) {
			const { data } = await axios.get("/cart.js", {
				headers: { Pragma: "no-cache" }
			});
			commit("data", data);
		},

		async add({ dispatch, commit }, { id, quantity, designer }) {
			try {
				await axios.post(
					"/cart/add.js",
					{
						id,
						quantity,
						properties: {
							designer: designer
						}
					},
					{ "X-Requested-With": "XMLHttpRequest" }
				);
			} catch (err) {
				console.error(err);
			}

			await dispatch("getData");
			commit("open", true);
			window.timeoutRef = setTimeout(() => {
				commit("open", false);
			}, 8000);
		},
		async change({ dispatch }, { id, quantity }) {
			try {
				await axios.post("/cart/change.js", {
					id: id.toString(),
					quantity
				});
			} catch (error) {
				console.log(error);
			}
			await dispatch("getData");
		},

		async toggleDrawer({ commit }, status) {
			await localStorage.setItem("openDrawer", JSON.stringify(status));
			commit("open", status);
		}
	},
	getters: {
		data(state) {
			return state.data;
		},
		open(state) {
			return state.open;
		}
	}
};
